import { useMeFavouritePartner, type WalletCustody } from '@capsicum/common';
import { usePartners } from '@capsicum/socios-core';
import { useCallback } from 'react';

import { useMyCollectiblesQuery } from '../data-access/queries';
import { type MyCollectible, type MyCollectibles } from '../models';
import { mapPartnerToCollectiblePartner } from '../util';

/**
 * @returns favorite partner collectibles and other collectibles owned by user
 */
export const useMyCollectibles = (walletCustody: WalletCustody) => {
	const { favoritePartner } = useMeFavouritePartner();
	const { getPartnerBy } = usePartners();

	return useMyCollectiblesQuery(
		useCallback(
			(data): MyCollectibles | undefined =>
				data?.reduce(
					(myCollectibles, collectible) => {
						const partnerId = collectible?.summary?.references?.partnerId;
						const partner = getPartnerBy(p => p.id === partnerId);

						const myCollectible: MyCollectible = {
							...collectible,
							partner: mapPartnerToCollectiblePartner(partner)
						};

						if (partnerId === favoritePartner?.id) {
							myCollectibles.favoriteCollectibles.push(myCollectible);
						} else {
							myCollectibles.collectibles.push(myCollectible);
						}

						return myCollectibles;
					},
					{
						collectibles: [],
						favoriteCollectibles: []
					} as MyCollectibles
				),
			[favoritePartner?.id, getPartnerBy]
		),
		{
			direction: 'desc',
			orderBy: 'createdAt',
			walletCustody
		}
	);
};
